import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  cta?: boolean; // deprecated, use variant
  loading?: boolean;
  variant?: 'primary' | 'secondary' | 'cta' | 'text' | 'text-light' | 'danger';
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  cta = false,
  loading = false,
  variant,
  children,
  className = '',
  disabled,
  ...props
}) => {
  // Support legacy cta prop for now
  const resolvedVariant = variant || (cta ? 'cta' : 'primary');
  let style = '';
  if (resolvedVariant === 'cta') {
    style = 'bg-yellow-400 hover:bg-yellow-300 text-black border-yellow-500 focus:ring-yellow-500 border-2';
  } else if (resolvedVariant === 'secondary') {
    style = 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 focus:ring-blue-400';
  } else if (resolvedVariant === 'text') {
    style = 'bg-transparent border-none text-gray-600 hover:underline p-0 m-0 shadow-none focus:ring-0 font-normal';
  } else if (resolvedVariant === 'text-light') {
    style = 'bg-transparent border-none text-gray-100 hover:underline p-0 m-0 shadow-none focus:ring-0 font-normal';
  } else if (resolvedVariant === 'danger') {
    style = 'bg-red-600 hover:bg-red-700 text-white border border-red-600 focus:ring-red-400';
  } else {
    // primary
    style = 'bg-blue-600 hover:bg-blue-700 text-white border border-blue-600 focus:ring-blue-400';
  }

  const isText = ['text', 'text-light'].includes(resolvedVariant);

  const base = resolvedVariant === 'cta'
    ? 'font-bold rounded-full shadow-sm transition-colors duration-150 focus:outline-none focus:ring-2 px-6 py-2.5 text-base flex items-center justify-center'
    : 'font-bold rounded-md shadow-sm transition-colors duration-150 focus:outline-none focus:ring-2 px-6 py-3 text-base flex items-center justify-center';
  return (
    <button
      className={[
        isText ? 'inline-flex items-center' : base,
        style,
        loading ? 'opacity-60 cursor-not-allowed' : '',
        className,
      ].join(' ')}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <svg className="animate-spin mr-2 h-4 w-4 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
        </svg>
      )}
      {children}
    </button>
  );
};
